module.exports = __webpack_public_path__ + "static/media/logo.50c913bf.jpeg";